import { faBars, faBarsStaggered, faBell, faBracketCurly, faCalendarAlt, faCodeBranch, faCogs, faFile, faFileChartColumn, faFileUser, faHardDrive, faList, faObjectGroup, faRetweet, faSquareSliders, faTable, faUsers, } from '@fortawesome/pro-regular-svg-icons';
export var defaultPatchSchema = [
    {
        label: 'Core Logic',
        type: 'logic',
        category: 1,
        display: 'block',
        options: [
            {
                label: 'Authentication',
                type: 'logic',
                icon: faFileUser,
                options: [
                    {
                        label: 'Login',
                        value: 'login',
                    },
                    {
                        label: 'Signup',
                        value: 'signup',
                    },
                    {
                        label: 'Logout',
                        value: 'logout',
                    },
                    {
                        label: 'Reset Password',
                        value: 'reset_password',
                    },
                    {
                        label: 'Change Password',
                        value: 'change_password',
                    },
                    {
                        label: 'Is LoggedIn',
                        value: 'auth',
                    },
                ],
            },
            {
                label: 'Native App Logic',
                type: 'logic',
                icon: faCogs,
                options: [
                    {
                        label: 'Open Map',
                        value: 'open_map',
                    },
                    {
                        label: 'Open Camera/Gallery',
                        value: 'open_camera',
                    },
                    {
                        label: 'Add to Calendar',
                        value: 'add_to_calendar',
                    },
                    {
                        label: 'Go to Settings',
                        value: 'go_to_settings',
                    },
                    {
                        label: 'Open Web Page',
                        value: 'go_to_web',
                    },
                    {
                        label: 'PDF Download',
                        value: 'download',
                    },
                ],
            },
            {
                label: 'Data Refresh Logic',
                type: 'logic',
                icon: faRetweet,
                options: [
                    {
                        label: 'Refresh user groups',
                        value: 'groups_update',
                    },
                    {
                        label: 'Refresh patchwork',
                        value: 'patchwork_update',
                    },
                    {
                        label: 'Clean patchwork',
                        value: 'patchwork_clean',
                    },
                ],
            },
            {
                label: 'User Management',
                type: 'logic',
                icon: faUsers,
                options: [
                    {
                        label: 'Create User',
                        value: 'user_create',
                    },
                    {
                        label: 'Get User',
                        value: 'user_get',
                    },
                    {
                        label: 'Update User',
                        value: 'user_update',
                    },
                    {
                        label: 'Delete User',
                        value: 'user_delete',
                    },
                    {
                        label: 'Clear User Data',
                        value: 'user_data_delete',
                    },
                ],
            },
            {
                label: 'Dataset Management',
                type: 'logic',
                icon: faFileChartColumn,
                options: [
                    {
                        label: 'Add to Dataset',
                        value: 'add_to_dataset',
                    },
                    {
                        label: 'Fetch Dataset Item',
                        value: 'fetch_dataset_item',
                    },
                    {
                        label: 'Remove from Dataset',
                        value: 'remove_from_dataset',
                    },
                    {
                        label: 'Update Item from Dataset',
                        value: 'update_dataset',
                    },
                    {
                        label: 'Fetch Dataset',
                        value: 'fetch_dataset',
                    },
                ],
            },
            {
                label: 'User Groups',
                type: 'logic',
                icon: faObjectGroup,
                options: [
                    {
                        label: 'Make a User a Member of Group(s)',
                        value: 'add_user_to_groups',
                    },
                    {
                        label: 'Toggle User Group Membership',
                        value: 'add_to_group',
                    },
                    {
                        label: 'Remove a User from Group',
                        value: 'remove_from_group',
                    },
                    {
                        label: 'Check Group Membership',
                        value: 'user_group_check',
                    },
                    {
                        label: 'Check Child App Group Membership',
                        value: 'child_app_user_group_check',
                    },
                    {
                        label: 'Get User Groups',
                        value: 'get_user_groups',
                    },
                    {
                        label: 'Get Shared App User Groups',
                        value: 'get_child_user_groups',
                    },
                ],
            },
            {
                label: 'Push Notifications',
                type: 'logic',
                icon: faBell,
                options: [
                    {
                        label: 'Request Push Permissions',
                        value: 'push_permission_request',
                    },
                    {
                        label: 'Send Push Notification',
                        value: 'push_send',
                    },
                    {
                        label: 'Send Deep Linked Push Notification',
                        value: 'deep_linked_push_send',
                    },
                    {
                        label: 'Revoke Push Permissions',
                        value: 'push_permission_revoke',
                    },
                    {
                        label: 'Check Push Permissions',
                        value: 'push_permission_check',
                    },
                ],
            },
            {
                label: 'Notifications',
                type: 'logic',
                icon: faBell,
                options: [
                    {
                        label: 'Haptic Feedback',
                        value: 'haptic_feedback',
                    },
                    {
                        label: 'Toast Message',
                        value: 'toast',
                    },
                ],
            },
            {
                label: 'State Logic',
                type: 'logic',
                icon: faSquareSliders,
                options: [
                    {
                        label: 'Set State',
                        value: 'set_state',
                    },
                    {
                        label: 'Get State',
                        value: 'get_state',
                    },
                ],
            },
            {
                label: 'Global Storage Logic',
                type: 'logic',
                icon: faHardDrive,
                options: [
                    {
                        label: 'Set Global Storage',
                        value: 'set_global_storage',
                    },
                    {
                        label: 'Get Global Storage',
                        value: 'get_global_storage',
                    },
                ],
            },
            {
                label: 'Variable Logic',
                type: 'logic',
                icon: faFile,
                options: [
                    {
                        label: 'Set Variable',
                        value: 'set_variable',
                    },
                ],
            },
            {
                label: 'Environment Variable Logic',
                type: 'logic',
                icon: faSquareSliders,
                options: [
                    {
                        label: 'Get Environment Variable',
                        value: 'get_env',
                    },
                ],
            },
            {
                label: 'Data Logic',
                type: 'logic',
                icon: faTable,
                options: [
                    {
                        label: 'Math',
                        value: 'math',
                    },
                    {
                        label: 'Parse Number',
                        value: 'parse_number',
                    },
                    {
                        label: 'String Manipulation',
                        value: 'string_manipulation',
                    },
                    {
                        label: 'New Value',
                        value: 'new_value',
                    },
                    {
                        label: 'String Conditional',
                        value: 'string_conditional',
                    },
                    {
                        label: 'Encode/decode',
                        value: 'encode_decode',
                    },
                    {
                        label: 'Device',
                        value: 'device',
                    },
                ],
            },
            {
                label: 'Date Logic',
                type: 'logic',
                icon: faCalendarAlt,
                options: [
                    {
                        label: 'Date Manipulation',
                        value: 'date',
                        title: 'Date Manipulation',
                        info: "The Date Manipulation logic block allows to perform various operations on date and time values, such as adding or subtracting time, setting specific dates, and formatting outputs. It\u2019s essential for apps that track events and reminders, enabling developers to calculate remaining time and adjust dates based on user preferences effortlessly.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/date/date-manipulation.html',
                        youTubeId: 'epdzym1DfIU',
                    },
                    {
                        label: 'Date Query',
                        value: 'is_date',
                        title: 'Date Query',
                        info: "The Date Query logic block enables comparisons and conditions with dates and times, allowing developers to control the logic flow of their application based on date-based criteria. It\u2019s particularly useful in scenarios such as determining eligibility for promotions, where actions can be triggered if the current date falls within a specified range. This block simplifies date comparisons, returning true or false values to guide the application's logic effectively.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/date/date-query.html',
                        youTubeId: '-bkLlKQC6w0',
                    },
                    {
                        label: 'Get Date Unit',
                        value: 'get_date_unit',
                        title: 'Get Date Unit',
                        info: "The Get Date Unit logic block allows developers to extract specific components from a date, such as the day, month, or year, facilitating various calculations and formatting needs. This is particularly useful in applications like event management, where users may want to sort or view events based on these date details. The block supports two methods: extracting a specific date unit or calculating the difference between two dates. It outputs the extracted date unit as a numeric value, which can be utilized for further calculations or displayed in the app, enhancing the overall user experience.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/date/get-date-unit.html',
                        youTubeId: 'HwScdAIWKqE',
                    },
                ],
            },
            {
                label: 'JSON Logic',
                type: 'logic',
                icon: faBracketCurly,
                options: [
                    {
                        label: 'Json Manipulation',
                        value: 'json_manipulation',
                        title: 'Json Manipulation',
                        info: "The JSON Manipulation logic block allows user to easily manage JSON data within your app. You can add, update, or remove values, create new keys, and provide real-time feedback with toast messages, ensuring efficient data handling and user experience",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/json/json-manipulation.html',
                    },
                    {
                        label: 'Json Values To List',
                        value: 'json_to_list',
                        title: 'Json Values To List',
                        info: "The JSON Values to List logic block efficiently converts JSON data into a manageable list format, simplifying data handling in your applications. By transforming JSON objects into lists, this tool enhances user interface presentation and allows for easier manipulation of data.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/json/json-values-to-list.html',
                    },
                    {
                        label: 'Json To String',
                        value: 'json_stringify',
                        title: 'Json To String',
                        info: "The JSON to String logic block converts JSON data into a single string format, making it easier to handle and display within applications. This functionality allows developers to present user information and other data in a readable text format, enhancing user experience and data visibility.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/json/json-to-string.html',
                    },
                    {
                        label: 'String To Json',
                        value: 'json_parse',
                        title: 'String To Json',
                        info: "The String to JSON logic block converts properly formatted JSON strings into JSON objects, simplifying data manipulation in applications. This functionality is essential for apps that fetch data from external APIs, allowing developers to easily parse and work with the returned data.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/json/string-to-json.html',
                    },
                ],
            },
            {
                label: 'List Logic',
                type: 'logic',
                icon: faList,
                options: [
                    {
                        label: 'List Manipulation',
                        value: 'list_manipulation',
                        title: 'List Manipulation',
                        info: "'List Manipulation' logic block enables operations like adding, removing, sorting, and filtering items in lists, enhancing user experiences in applications such as e-commerce and data management.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/list/list-manipulation.html',
                        youTubeId: 'MgfiBBrF3Tk',
                    },
                    {
                        label: 'Get List Length',
                        value: 'list_length',
                        title: 'Get List Length',
                        info: "'Get List Length' logic block efficiently retrieves the numerical length of a list, allowing you to manage list data effectively, such as displaying item counts in shopping carts and making informed decisions.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/list/get-list-length.html',
                        youTubeId: '2hB833Do1gk',
                    },
                    {
                        label: 'List Conditional',
                        value: 'list_conditional',
                        title: 'List Conditional',
                        info: "'List Conditional' logic block allows you to apply conditions to lists, enabling evaluations like checking task completion or overdue items, enhancing user experience with dynamic summaries and actions.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/list/list-conditional.html',
                        youTubeId: 'LEmVVpMmsrc',
                    },
                    {
                        label: 'List Search',
                        value: 'list_search',
                        title: 'List Search',
                        info: "'List Search' logic block efficient searching within data lists, allowing users to find specific items like books by title or author, enhancing usability and streamlining data access in your application.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/list/list-search.html',
                        youTubeId: '_F68vTNKAQo',
                    },
                    {
                        label: 'List Shifting',
                        value: 'list_shifting',
                        title: 'List Shifting',
                        info: "'List Shifting' logic block lets user easily rearrange list elements by shifting them left or right, enhancing user interaction in applications like image carousels for a dynamic and organized experience.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/list/list-shifting.html\n',
                        youTubeId: 'yEOGU6B7udA',
                    },
                    {
                        label: 'List To String',
                        value: 'list_to_string',
                        title: 'List To String',
                        info: "'List to String' logic block converts a list of elements into a single string, making it easy to display data in a unified format, such as creating a comma-separated list of user names for your interface.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/list/list-to-string.html',
                        youTubeId: 'Qgh6tkbCzz4',
                    },
                    {
                        label: 'String To List',
                        value: 'string_to_list',
                        title: 'String To List',
                        info: "'String to List' logic block converts a string of elements into a manageable list, perfect for processing data like user emails separated by commas, simplifying the handling of string data in your applications.",
                        link: 'https://academy.appspotr.com/academy/latest/cms/editor/patchwork/logic/list/string-to-list.html',
                        youTubeId: 'OhJv9AOmzTo',
                    },
                ],
            },
            {
                label: 'OAuth',
                type: 'logic',
                icon: faCodeBranch,
                options: [
                    {
                        label: 'Authorize (generate Token)',
                        value: 'oauth_authorize',
                    },
                    {
                        label: 'Refresh Token',
                        value: 'oauth_refresh',
                    },
                    {
                        label: 'Revoke Token',
                        value: 'oauth_revoke',
                    },
                    {
                        label: 'OAuth Logout',
                        value: 'oauth_logout',
                    },
                ],
            },
        ],
    },
    {
        label: 'Menu',
        type: 'navigation',
        category: 2,
        display: 'tile',
        noAccordion: true,
        options: [
            {
                label: 'Menu',
                type: 'navigation',
                options: [
                    {
                        label: 'Main Menu',
                        value: 'drawer',
                        icon: faBars,
                    },
                    {
                        label: 'Sub Menu',
                        value: 'submenu',
                        icon: faBarsStaggered,
                    },
                ],
            },
        ],
    },
    {
        label: 'Navigation Logic',
        type: 'route',
        category: 2,
        display: 'block',
        noAccordion: false,
        options: [
            {
                label: 'Navigation',
                type: 'logic',
                options: [
                    {
                        label: 'Go Back',
                        value: 'go_back',
                    },
                    {
                        label: 'Toggle Drawer',
                        value: 'toggle_drawer',
                    },
                    {
                        label: 'Toggle Context Menu',
                        value: 'toggle_context_menu',
                    },
                    {
                        label: 'Toggle Sort Menu',
                        value: 'toggle_sort_menu',
                    },
                    {
                        label: 'If Condition',
                        value: 'conditional_navigation',
                    },
                    {
                        label: 'Go Home',
                        value: 'go_to_patch',
                    },
                    {
                        label: 'Wait',
                        value: 'set_timeout',
                    },
                    {
                        label: 'Async',
                        value: 'async_logic',
                    },
                    {
                        label: 'Loop',
                        value: 'loop_logic',
                    },
                ],
            },
        ],
    },
];
